<template>
  <div>
    <div slot="title">
      <h2>Detalles del Evaluado</h2>
    </div>
    <div slot="main">
      <div class="container-fluid">
        <div class="row" style="margin-top:20px">
          <div class="col-2">
            <button type="button" class="form-control" @click="$router.go(-1)"><i class="fa fa-arrow-left"></i><span class="col-form-label" style="margin-left:50px">Regresar</span></button>
          </div>
        </div>
        <div class="row">
          <div class="col-3" style="border-right:solid;padding-right:20px;">
            <div class="row">
              <div class="col-12"><h4><span class="col-form-label">Persona Evaluada</span></h4></div>
            </div>
            <div class="row" style="margin-top:10px;margin-bottom:10px;">
              <div class="col-12 d-flex justify-content-center" style="overflow:hidden">
                <img src="../../../../assets/usuario-sin-foto.png" class="thumb" />
                <!--<i data-v-6bbe8d3f="" class="fas fa-user-tie prof-pic"></i>-->
              </div>
              <div class="col-12">
                <div class="row"><span class="col-form-label"><b>Evaluado : </b>{{nombreEvaluado}}</span></div>
                <div class="row"><span class="col-form-label"><b>Estatus : </b>{{estatus}}</span></div>
                <div class="row"><span class="col-form-label"><b>Sección : </b>{{seccion}}</span></div>
                <div class="row"><span class="col-form-label"><b>Departamento : </b>{{departamento}}</span></div>
                <div class="row"><span class="col-form-label"><b>Puesto : </b>{{puesto}}</span></div>
                <div class="row"><span class="col-form-label"><b>Tipo Puesto : </b>{{tipoPuesto}}</span></div>
                <div class="row"><span class="col-form-label"><b>Periodo a Evaluar : </b>{{periodoEvaluacion}}</span></div>
              </div>
            </div>
          </div>
          <div class="col-9">
            <div class="row">
              <div class="col-5">
                <h5>
                  <span class="col-form-label">
                    Evaluadores Asignados <span class="badge badge-light">{{evaluadoresAsignados}}</span>
                  </span>
                </h5>
              </div>
              <div class="col-3"></div>
            </div>
            <div class="row">
              <div class="col-12">
                <ul class="nav nav-tabs" id="tabResultados" role="tablist">
                  <li class="nav-item">
                    <a class="nav-link active" id="Poligono-tab" data-toggle="tab" href="#Poligono" role="tab" aria-controls="Poligono" aria-selected="true">Fortalezas y oportunidades</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" id="Barras-tab" data-toggle="tab" href="#Barras" role="tab" aria-controls="Barras" aria-selected="false">Comentario de Admninistración de Personal</a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade show active" id="Poligono" role="tabpanel" aria-labelledby="Poligono-tab">
                <div class="row" style="margin-top:30px; margin-left:20px;">
                  <div class="col-12">
                    <table class="table table-striped table-light table-hover" id="tablaEvaluadores">
                      <thead class="thead-dark">
                        <tr>
                          <th>Fortalezas</th>
                          <th>Areas de Oportunidad</th>
                        </tr>
                      </thead>
                      <tbody class="text-dark">
                        <tr>
                          <td><ul><li v-for="Fortaleza in Fortalezas">{{Fortaleza}}.</li></ul><span v-if="Fortalezas.length <= 0">No se detectaron fortalezas.</span></td>
                          <td><ul><li v-for="Oportunidad in Oportunidades">{{Oportunidad}}.</li></ul><span v-if="Oportunidades.length <= 0">No se detectaron areas de oportunidad.</span></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" id="Barras" role="tabpanel" aria-labelledby="Barras-tab">
                <div class="row" style="margin-top:30px; margin-left:20px;">
                  <div class="col-12">
                    <h5 style="background-color:#2e2f31; padding: 10px;">{{comentario}}</h5>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import comun from '@/../static/js/comun'
  import enumeraciones from '@/../static/js/enumeraciones'
  import api from '@/../static/js/api'
  import axios from 'axios'
  import Vue from 'vue'
  import Vuex from 'vuex'
  import store from '@/store/index'
  import highcharts from '@/../static/js/highchart'

  export default {
    props: ['idEvaluacion', 'infoPersona'],//Recibe como parametro el id de evaluación
    data() {
      return this.datosIniciales()
    },
    components: {
      highcharts
    },
    methods: {
      datosIniciales() {
        return {//asigna los valores iniciales del data
          nombreEvaluado: "",//Almacena el nombre del evaluado
          estatus: "Desconocido",//Almacena el estatusde la evaluación
          seccion: "",//Almacena la sección del evaluado
          departamento: "",//Almacena el departamento del evaluado
          puesto: "",//Almacena el puesto del evaluado
          tipoPuesto: "",//Almacena el tipo de contrato del evaluado
          periodoEvaluacion: "",//Almacena el periodo de evaluación
          evaluadoresAsignados: 0,//Almacena la cantidad de evaluadores asignados
          evaluadoId: 0,//Guarda el id del evaluado
          asignadosIniciales: false,
          evaluadores: [],
          comentario: "",
          terminado: false,
          comentado: false,
          competencias: ['Autocontrol y estabilidad emocional',
            'Confianza y seguridad en sí mismo',
            'Resistencia a la adversidad',
            'Comunicación',
            'Establecimiento de relaciones',
            'Negociación',
            'Trabajo en equipo',
            'Iniciativa',
            'Orientación a resultados',
            'Capacidad de análisis',
            'Toma de decisiones',
            'Conocimiento de la institución',
            'Orientación al usuario',
            'Apertura',
            'Identificación con la institución',
            'Visión y Anticipación',
            'Dirección',
            'Liderazgo',
            'Planificación y organización'
          ],
          Fortalezas: [],
          Oportunidades: []

        }


      },
      cargarDatosEvaluacion: function () {//Hace la petición para recibir los datos generales sobre la evaluación a mostrar
        //Carga los datos para hacer la peticion
        var peticion = {
          "esPrueba": false,
          "idEvaluacion": this.idEvaluacion
        };
        axios.post(api.conexion + api.SISEVA.funcion.GetEvaluacion, peticion).then(response => {
          if (response.data.SiHayError == false) {
            console.log(response.data)
            var evaluacion = response.data.evaluacion
            this.estatus = evaluacion.Estatus
            if (this.estatus == "Terminado") {
              this.terminado = true
            }
            var evaluadores = response.data.evaluacion.evaluadores
            this.asignadosIniciales = (evaluadores.length > 0)
            if (this.asignadosIniciales) {
              this.buscarEvaluadoresAsignados();
            }
            this.nombreEvaluado = evaluacion.nombreEvaluado
            this.seccion = evaluacion.Seccion
            this.departamento = evaluacion.Departamento
            this.puesto = evaluacion.Puesto
            this.tipoPuesto = evaluacion.TipoPlaza
            this.periodoEvaluacion = evaluacion.FechaInicioPeriodoEvaluacionString + " - " + evaluacion.FechaFinPeriodoEvaluacionString
            this.evaluadoresAsignados = evaluacion.noCuestionarios
            this.evaluadoId = evaluacion.EvaluadoId
            this.comentario = evaluacion.ObservacionRH
            var PerfilCompetencias = evaluacion.PerfilCompetencias
            var Fortalezas = []
            var Oportunidades = []
            var competencias = this.competencias
            evaluacion.ResultadoCategorias.forEach(function callback(currentValue, index, array) {
              if (currentValue != null) {
                if (currentValue > PerfilCompetencias[index]) {
                  Fortalezas.push(competencias[index])
                } else if (currentValue + 1.5 < PerfilCompetencias[index]) {
                  Oportunidades.push(competencias[index])
                }
              }
            });
            this.Fortalezas = Fortalezas
            this.Oportunidades = Oportunidades

            //this.chartOptions.series[0].data = evaluacion.PerfilCategorias
            //this.chartOptions2.series[0].data = evaluacion.PerfilCompetencias
            //this.chartOptions.series[1].data = evaluacion.ResultadoCategorias
            //this.chartOptions2.series[1].data = evaluacion.ResultadoCompetencias

            if (this.comentario != null) {
              this.comentado = true
            }
            //Extrae los resultados de la petición pára insertarlos en la vista
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      },
      buscarEvaluadoresAsignados: function () {//Hace la petición para obtener a los evaluadores de la evaluación
        //Carga los valores requeridos para hacer la petición
        var peticion = {
          "esPrueba": false,
          "idEvaluacion": this.idEvaluacion
        };
        axios.post(api.conexion + api.SISEVA.funcion.GetEvaluadores, peticion).then(response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa

            this.evaluadores = response.data.evaluadores//Carga los datos requeridos

          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      }/*, cargarResultadosEvaluacion: function () {//Hace la petición para recibir los datos generales sobre la evaluación a mostrar
        //Carga los datos para hacer la peticion
        var peticion = {
          "esPrueba": false,
          "EvaluacionId": this.idEvaluacion
        };
        axios.post(api.conexion + api.SISEVA.funcion.GetResultadoEvaluacion, peticion).then(response => {
          if (response.data.SiHayError == false) {
            alert('hola')
            this.chartOptions.series[1].data = response.data.ResultadoCategorias
            this.chartOptions.xAxis.categories = response.data.NombreCategorias
            this.chartOptions2.series[1].data = response.data.ResultadoCompetencias
            this.chartOptions2.xAxis.categories = response.data.NombreCompetencias
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      }*/,
      guardarComentario: function () {
        var peticion = {
          "esPrueba": false,
          "EvaluacionId": this.idEvaluacion,
          "comentario": this.comentario
        };
        axios.post(api.conexion + api.SIAP.funcion.GuardarComentarioEvaluacion, peticion).then(response => {
          if (response.data.SiHayError == false) {
            comun.mensajeDeAlerta("Comentario guardado correctamente", null, null)
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      },
      CancelarResultadoEvaluacion: function (idCuestionario) {
        var peticion = {
          "esPrueba": false,
          "idCuestionario": idCuestionario
        };
        axios.post(api.conexion + api.SISEVA.funcion.CancelarResultadoEvaluacion, peticion).then(response => {
          if (response.data.SiHayError == false) {
            this.cargarDatosEvaluacion();
            this.cargarResultadosEvaluacion();
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      },
      QuitarEvaluador: function (idCuestionario) {
        var peticion = {
          "esPrueba": false,
          "idCuestionario": idCuestionario
        };
        axios.post(api.conexion + api.SISEVA.funcion.QuitarEvaluador, peticion).then(response => {
          if (response.data.SiHayError == false) {
            this.cargarDatosEvaluacion();
            this.cargarResultadosEvaluacion();
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      }
    },
    computed: {

    }, mounted: function mounted() {//Carga la información de la evaluación y la lista de cuestionarios al principio
      this.cargarDatosEvaluacion();
      //this.cargarResultadosEvaluacion();
    }

  }

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/SISEVA/Evaluaciones/Evaluacion/ResultadoPersonal.vue